import { Download, People } from '@mui/icons-material';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import { Alert, Box, Button, Paper, PaperProps, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ScenarioIcon } from '../../../../components/icons/CustomIcons';
import { PageHeader } from '../../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../../layout';
import { getConfig } from '../../../../utils/config';

const TRANS_NS = 'universal-reminding';

export const UniversalTemplatePage = () => {
  const { t } = useTranslation(TRANS_NS);

  return (
    <PageLayout>
      <PageHeader title={t('title')} subtitle={t('template.title')} backRouteTo={null} />
      <PageContent
        sx={{
          gap: 4,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Alert severity={'info'} sx={{ p: 2, whiteSpace: 'break-spaces' }}>
          {t('template.info')}
        </Alert>
        <UniversalTemplateProcess sx={{ minWidth: { lg: '768px' } }} />
      </PageContent>
    </PageLayout>
  );
};

const { universalTemplateUrl } = getConfig();
const UniversalTemplateProcess = (props?: PaperProps) => {
  const { t } = useTranslation(TRANS_NS);
  return (
    <Paper {...props} sx={{ ...(props?.sx ? props.sx : {}), py: 2 }}>
      <Typography variant={'h5'} align={'center'}>
        {t('template.process.title')}
      </Typography>
      <Timeline position={'alternate'}>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Typography>{t('template.process.step1.title')}</Typography>
            <Box mt={1}>
              <Button
                variant={'contained'}
                component={'a'}
                href={universalTemplateUrl}
                download={'upominej-universal-template.xlsx'}
                startIcon={<Download />}
              >
                {t('template.download')}
              </Button>
            </Box>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Typography>{t('template.process.step2.title')}</Typography>
            <Typography variant={'caption'} color={'text.secondary'}>
              <Trans
                t={t}
                i18nKey={'template.process.step2.subtitle'}
                components={{
                  bold: <Typography variant={'inherit'} component={'span'} fontWeight={'bold'} />,
                }}
              />
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Typography>{t('template.process.step3.title')}</Typography>
            <Typography variant={'caption'} color={'text.secondary'} whiteSpace={'break-spaces'}>
              <Trans
                t={t}
                i18nKey={'template.process.step3.subtitle'}
                components={{
                  bold: <Typography variant={'inherit'} component={'span'} fontWeight={'bold'} />,
                }}
              />
            </Typography>
            <Box mt={1}>
              <Button
                component={Link}
                to={'/admin/universal-reminding/scenarios'}
                variant={'outlined'}
                endIcon={<ScenarioIcon />}
              >
                {t('universalReminding.scenarios', { ns: 'admin' })}
              </Button>
            </Box>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Typography>{t('template.process.step4.title')}</Typography>
            <Typography variant={'caption'} color={'text.secondary'} whiteSpace={'break-spaces'}>
              <Trans
                t={t}
                i18nKey={'template.process.step4.subtitle'}
                components={{
                  bold: <Typography variant={'inherit'} component={'span'} fontWeight={'bold'} />,
                }}
              />
            </Typography>
            <Box mt={1}>
              <Button component={Link} to={'/admin/users'} variant={'outlined'} endIcon={<People />}>
                {t('users', { ns: 'admin' })}
              </Button>
            </Box>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="primary" variant="outlined" />
          </TimelineSeparator>
          <TimelineContent>
            <Typography> {t('template.process.step5.title')}</Typography>
            <Typography variant={'caption'} color={'text.secondary'} whiteSpace={'break-spaces'}>
              {t('template.process.step5.subtitle')}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </Paper>
  );
};
